export default "__VITE_ASSET__BWajFCyD__"